module.exports = __webpack_public_path__ + "static/media/Bathroom Tub Towel (1).bc5202fd.svg";